module.exports = __webpack_public_path__ + "img/bga.92828327.png";